import validateDni from './dniValidator'

const validateNie = (id: string): boolean => {
  const NIE_REGEX = /^[XYZ]\d{7,8}[A-Z]$/

  id = id.toUpperCase().replace(/\s/g, '')
  if (!NIE_REGEX.test(id)) {
    return false
  }

  let nie_prefix = id.charAt(0)

  switch (nie_prefix) {
    case 'X':
      nie_prefix = '0'
      break
    case 'Y':
      nie_prefix = '1'
      break
    case 'Z':
      nie_prefix = '2'
      break
  }

  return validateDni(nie_prefix + id.substring(1))
}

export default validateNie
